/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";

import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";
import { Select } from "@material-ui/core";

function CustomSelect({ ...props }) {
  const {
    classes,
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    type,
    isInputText,
    inputText = '',
    selectContent,
  } = props;

  const [filterText, setFilterText] = useState(inputText);

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
  });

  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });
  var inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });

  if (inputClasses === null || inputClasses === undefined) {
    inputClasses = "";
  }

  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });


  const handleFilterChange = (e) => {
    const text = e.target.value;
    setFilterText(text);

    // Automatically select the first filtered option
    const firstMatch = selectContent.find((item) => {
      const itemText = typeof item.props.children === "string" ? item.props.children : "";
      return itemText.toLowerCase().includes(text.toLowerCase());
    });

    if (firstMatch) {
      inputProps?.onChange({ target: { value: firstMatch.props.value } });
    }
  };

  const filteredContent = (selectContent || []).filter((item) => {
    const text = typeof item?.props?.children === "string" ? item.props.children : "";
    return text.toLowerCase().includes(filterText.toLowerCase());
  });

  return (

    <FormControl {...formControlProps} className={formControlClasses}>
      {isInputText ? (
        <div style={{display: "flex"}}>
          <div style={{ padding: "8px" }} autoFocus>
            <Input
              placeholder="Escriba para buscar..."
              value={filterText}
              onChange={handleFilterChange}
              autoFocus={true}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <select
            id={id}
            value={inputProps?.value || ""}
            onChange={inputProps?.onChange}
            style={{
              width: "200px",
              height: "40px",
              padding: "8px",
              borderRadius: "4px",
              border: "0px solid #ccc",
              backgroundColor:"transparent",
              marginTop: isInputText ? "10px" : "0",
            }}
          >   <option value="" disabled>
              * Seleccione una opción
            </option>
            {filteredContent.length > 0 ? (
              filteredContent.map((item, index) => (

                <option key={item.key || index} value={item.props.value}>
                  {item.props.children}
                </option>
              ))
            ) : (
              <option disabled>No hay opciones</option>
            )}
          </select>
        </div>
      ) : (
        <div>   {labelText !== undefined ? (
          <InputLabel
            style={{ margin: "0px 0px 0px 0px" }}
            className={classes.labelRoot + " " + labelClasses}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        ) : null}
          <Select
            style={{ margin: "0px 0px 0px 0px", minWidth: "150px", width:"100%" }}
            classes={{
              //input: inputClasses,
              root: marginTop,
              disabled: classes.disabled,
            }}
            type={type}
            id={id}
            {...inputProps}
          >
            {selectContent}
          </Select>
        </div>
      )}



      {helperText !== undefined ? (
        <FormHelperText id={id + "-text"} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

CustomSelect.propTypes = {
  isInputText: PropTypes.bool,
  inputText: PropTypes.string,
  onChange: PropTypes.object,
  selectContent: PropTypes.array,
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
};

export default withStyles(customInputStyle)(CustomSelect);
